import React from 'react';
const DisabledSVG = ({ color = '#0000008c' }) => {
    return (React.createElement("svg", { className: 'svg--no-margin', width: "7", height: "7", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { id: "Circle", cx: "50%", cy: "50%", r: "5", stroke: color, strokeWidth: "1px", fill: "white" })));
};
export default DisabledSVG;
